import { AttributeType } from "@interfaces/attribute.interface";

/** Year-attribute range. Mirrors the backend (1500 .. current_year + 100) and oberon. */
export const MIN_YEAR = 1500;
export const MAX_YEAR_OFFSET = 100;

/** Used when neither the entity nor the organization resolves a currency. Matches oberon. */
export const DEFAULT_CURRENCY_SYMBOL = "$";

export const SINGLE_SELECT_ATTRIBUTE_TYPES = [
  AttributeType.DROPDOWN,
  AttributeType.SCOUT_CLASSIFY,
  AttributeType.SCOUT_SCORE,
];

export const DROPDOWN_ATTRIBUTE_TYPES = [
  ...SINGLE_SELECT_ATTRIBUTE_TYPES,
  AttributeType.MULTISELECT,
];

/** Deliberately not in DROPDOWN_ATTRIBUTE_TYPES: these store record pointers, not option ids. */
export const RELATION_ATTRIBUTE_TYPES = [AttributeType.RELATION];

export const isRelationAttribute = (type: AttributeType): boolean =>
  RELATION_ATTRIBUTE_TYPES.includes(type);

export const TEXT_ATTRIBUTE_TYPES = [AttributeType.TEXT, AttributeType.SCOUT_EXTRACT];

export const NUMBER_ATTRIBUTE_TYPES = [
  AttributeType.NUMBER,
  AttributeType.NUMBER_NOT_NEGATIVE,
  AttributeType.YEAR,
];
